import React, { useEffect, useState } from "react";
import HomeServices from "../../Services/HomeServices";
import DataTable from "react-data-table-component";
import BackPageBtn from "../BackButton/BackPageBtn";
import { CSVLink } from "react-csv";

const UserEmail = () => {
  const csvHeaders = [
    { label: "SL No.", key: "sln" },
    { label: "Email ID", key: "email" },
  ];
  const [userEmailData, setUserEmailData] = useState();
  const columns = [
    { name: "SL No.", selector: "sln", sortable: true },
    { name: "Email ID", selector: "email", sortable: true },
  ];
  const fetchData = async () => {
    try {
      // Call your API function
      const response = await HomeServices.viewUserEmail();
      console.log("hvhg8798dcjs", response);
      if (response && response?.status) {
        let arr = response?.data?.reverse()?.map((ele, index) => {
          return {
            sln: index + 1,
            email: ele?.email,
          };
        });
        setUserEmailData(arr);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="d-flex justify-content-end mx-2">
        <div className="form-header">
          <section className="piechartsBox_area">
            {/* <BackPageBtn backLink="/" /> */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h1 style={{ color: "#ff9c00" }}>View User Email</h1>
              {userEmailData?.length > 0 && (
                <CSVLink
                  style={{ backgroundColor: "#ff9c00", height: "40px" }}
                  data={userEmailData}
                  headers={csvHeaders}
                  filename="user_emails.csv"
                  className="btn btn-primary"
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <span>Download CSV</span>
                    <i class="fa-regular fa-circle-down"></i>
                  </div>
                </CSVLink>
              )}
            </div>
            <hr />
            <DataTable columns={columns} data={userEmailData} pagination />
          </section>
        </div>
      </div>
    </>
  );
};

export default UserEmail;
